import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, Router } from '@angular/router';

import { LogUtil } from '../utils/log.util';
import { USER_TOKEN_STORAGE_NAME, FUNCTIONARY_LOGIN_STORAGE_NAME } from '../constants/storage.constant';
import { DBService } from '../services/db.service';

@Injectable({
	providedIn: 'root'
})
export class UserGuard implements CanLoad {

	constructor(
		private _dbService: DBService,
		private _router: Router
	) { }

	async canLoad(route: Route, segments: UrlSegment[]): Promise<boolean> {
		const token = await this._dbService.get(USER_TOKEN_STORAGE_NAME);
		const functionaryLogin = await this._dbService.get(FUNCTIONARY_LOGIN_STORAGE_NAME);

		if (!token || !functionaryLogin) {
			LogUtil.sendLog("UserGuard no token. go to login");
			this._router.navigateByUrl('/login');
			return false;
		}
		LogUtil.sendLog("UserGuard can load");
		return true;
	}
}
